import { loggerService } from "@akina/infra";
import { isApp } from "@akina/utils";

const LOGGING_DOMAIN = "[network-status-monitor]";

export type NetworkStatusInfo = {
  isOnline: boolean;
};

type NetworkStatusCallback = (info: NetworkStatusInfo) => void;

export type NetworkStatusMonitor = {
  start: () => Promise<void>;
  stop: () => void;
};

export function createNetworkStatusMonitor(callback: NetworkStatusCallback): NetworkStatusMonitor {
  let isStopped = false;

  async function start(): Promise<void> {
    if (!isApp) {
      callback({ isOnline: true });
      return;
    }

    try {
      const { Channel, invoke } = await import("@tauri-apps/api/core");
      const channel = new Channel<NetworkStatusInfo>();

      channel.onmessage = (info: NetworkStatusInfo) => {
        if (isStopped) return;
        callback(info);
      };

      await invoke("watch_network_status", { onEvent: channel });
    } catch (error) {
      loggerService.warn(LOGGING_DOMAIN, "Failed to setup network status channel:", error);
    }
  }

  function stop(): void {
    isStopped = true;
  }

  return { start, stop };
}
